import type {GlobalNavigationContext} from './refresh-global-navigation'

/** The parts of a context that identify its context object, without the destination path or selected tab. */
export type GlobalNavigationContextCrumb = Pick<
  GlobalNavigationContext,
  'crumbType' | 'crumbObjectIdentifier' | 'scope'
>

export function getRepositoryContextCrumb(nameWithOwner: string): GlobalNavigationContextCrumb {
  return {crumbType: 'repository', crumbObjectIdentifier: nameWithOwner, scope: `/${nameWithOwner}`}
}
